import { HStack, Button } from '@cad-arc';
import { ReactElement } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';
import { FR_SEARCH_FORM_FOOTER_HEIGHT_PX, SEARCH_FORM_FOOTER_HEIGHT_PX } from './constants';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useBulkExportEventSearchResultsMutation } from '../event-search/use-bulk-export-event-search-results-mutation';
import { useFormContext } from 'react-hook-form';
import { EventSearchForm } from '@mark43/cad-api';
import { generateEnhancedSearchReport, prepareForSubmit } from '../event-search/utils';
import { EventSearchFormType } from '../event-search/types';

export function SearchFormFooter({
    children,
    isFormValid,
    onClearAllFields,
    isAgencyEvent,
}: {
    children?: ReactElement;
    isFormValid: boolean;
    onClearAllFields: () => void;
    isAgencyEvent?: boolean;
}) {
    const { isFirstResponder } = useApplicationType();
    const enhancedExportsEnabled = useEnabledFeatures().enhancedSearchExportsEnabled;
    const form = useFormContext<EventSearchForm>();
    const bulkEventSearchExportMutation = useBulkExportEventSearchResultsMutation();

    const { open } = useFullscreenModalControls();
    return (
        <HStack
            h={`${
                isFirstResponder ? FR_SEARCH_FORM_FOOTER_HEIGHT_PX : SEARCH_FORM_FOOTER_HEIGHT_PX
            }px`}
            w="100%"
            justifyContent="space-between"
            padding="var(--arc-space-4) var(--arc-space-6)"
            backgroundColor="var(--arc-colors-surface-foreground)"
            borderTop="1px solid var(--arc-colors-border-default)"
        >
            {children}
            <HStack>
                {enhancedExportsEnabled && isAgencyEvent && (
                    <Button
                        isDisabled={!isFormValid}
                        onClick={() =>
                            generateEnhancedSearchReport({
                                eventIds: [],
                                open,
                                bulkEventSearchExportMutation,
                                eventSearchForm: prepareForSubmit(
                                    (form.getValues() as unknown) as EventSearchFormType
                                ),
                            })
                        }
                    >
                        Generate Log
                    </Button>
                )}
                <Button variant="ghost" onClick={() => onClearAllFields()}>
                    Clear All Fields
                </Button>
                <FormSaveButton data-testid="search-form-search-button" isDisabled={!isFormValid}>
                    Search
                </FormSaveButton>
            </HStack>
        </HStack>
    );
}
